import { Artist, User } from "@/types/types";
import { isFreeUser } from "@/utils/subscriptionLevels/isFreeUser";

export const isAllowedArtist = (
  stripeSubscriptionId: User["stripeSubscriptionId"],
  artist: Artist
) => {
  const paidArtist = !artist.meta.free;
  const freeUser = isFreeUser(stripeSubscriptionId);

  if (freeUser && paidArtist) {
    return false;
  }
  {
    return true;
  }
};
